import Users from './Users';

/**
 * Orders Page - Wrapper for React Router
 */
function UsersPage() {
	return <Users />;
}

export default UsersPage;
